<template>
  <div class="page">
    <div class="item-title">资金统计</div>
    <div class="item-line"></div>
    <el-row type="flex" class="row-bg">
      <!-- 实际入账金额 -->
      <el-col :span="7" align="center">
        <div
          id="incomeAmount"
          style="margin-top: 20px; width: 80%; height: 300px"
        ></div>
        <el-tag type="info">实际入账金额 = 总入账金额 - 总退款金额</el-tag>
      </el-col>
      <el-col :span="5" align="center">
        <!-- 总入账金额 -->
        <div
          id="incomeAmountDetails"
          style="margin-top: 20px; width: 100%; height: 250px"
        ></div>
      </el-col>
      <el-col :span="5" align="center">
        <!-- 总退款金额 -->
        <div
          id="refundAmount"
          style="margin-top: 20px; width: 100%; height: 250px"
        ></div>
      </el-col>
      <!-- 待缴金额 -->
      <el-col :span="7" align="center">
        <div
          id="awaitIncomeAmount"
          style="margin-top: 20px; width: 80%; height: 300px"
        ></div>
      </el-col>
    </el-row>
    <div class="item-title">账单统计</div>
    <div class="item-line"></div>
    <el-row type="flex" class="row-bg">
      <el-col :span="16">
        <!-- 缴费项目统计柱状图 -->
        <div
          id="paymentProject"
          style="margin-top: 20px; width: 100%; height: 400px"
        ></div>
      </el-col>
      <el-col :span="8">
        <div style="height: 50px"></div>
        <el-row type="flex" class="row-bg">
          <el-col :span="10">
            <!-- 缴费总计：应收 -->
            <div
              id="paymentTotal"
              style="margin-top: 20px; width: 100%; height: 250px"
            ></div>
          </el-col>
          <el-col :span="10">
            <!-- 缴费来源 -->
            <div
              id="paymentSource"
              style="margin-top: 20px; width: 100%; height: 250px"
            ></div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import moment from "moment";
import { Loading } from "element-ui";

import mixins from "../../minix";

let _vue;

export default {
  name: "Count",

  mixins: [mixins],

  data() {
    return {
      countall: {
        totalAmount: "",
        paidAmount: "",
        unpaidAmount: "",
        balanceAmount: "",
      },
      settle: {
        totalAmount: "",
        paidAmount: "",
        unpaidAmount: "",
      },
      daterange: "",
      daterangePaid: "",
      listData: [],
      pricings: [],
      dialogVisible: false,
      houseNameRegex: "",
      areaIDSelect: ["全部区域"],
      pricingTypes: ["分期", "一次性", "按量"],
      areaProps: {
        checkStrictly: true,
        lazy: true,
        async lazyLoad(node, resolve) {
          let superAreaID = "";
          if (node.level > 0) {
            superAreaID = node.data.value;
          }
          let list = await _vue.areasQuery(superAreaID);
          let resolveData = [];
          if (list) {
            list.forEach((item) => {
              resolveData.push({
                value: item.id,
                label: item.name,
              });
            });
          }
          if (node.level === 0) {
            resolveData.unshift({
              value: "全部区域",
              label: "全部区域",
            });
          }
          resolve(resolveData);
        },
      },

      option: {
        title: {
          text: 0,
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: (v) => {
            return v.data.name + " ￥" + this.numFormat(v.data.value);
          },
        },
        legend: {
          orient: "vertical",
          // left: 0,
          bottom: 0,
          right: 0,
        },
        series: [
          {
            type: "pie",
            radius: "50%",
            data: [],
            label: {
              normal: {
                position: "inner",
                show: false,
              },
            },
            emphasis: {},
          },
        ],
      },
    };
  },

  created() {
    _vue = this;

    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.daterange = [moment().startOf("month"), moment().endOf("month")];
    this.daterangePaid = [moment().startOf("month"), moment().endOf("month")];
  },

  mounted() {
    this.setCartogram();
  },
  methods: {
    // 设置饼图 divID、 账单金额、饼图标题、饼图数据
    setPieData(divId, titleText, titleSubtext, pieData, colors) {
      let divData = this.$echarts.init(document.getElementById(divId));
      let divDataPie = { ...this.option };
      divDataPie.title.text = titleText;
      divDataPie.title.subtext = titleSubtext;
      divDataPie.series[0].data = pieData;
      divDataPie.title.textStyle = {
        fontSize: 25,
      };
      // 总入账金额
      if (divId == "incomeAmount"|| divId=="awaitIncomeAmount") {
        divDataPie.series[0].radius = "60%";
        divDataPie.legend = {
          orient: "vertical",
          // left: 0,
          bottom: 50,
          right: 0,
        };
      } else {
        divDataPie.series[0].radius = "50%";
      }
      divDataPie.series[0].itemStyle = {
        shadowBlur: 0,
        shadowOffsetX: 0,
        shadowColor: "rgba(0, 0, 0, 0.5)",
        normal: {
          color: function (params) {
            //自定义颜色
            var colorList = colors;
            return colorList[params.dataIndex];
          },
        },
      };
      divData.setOption(divDataPie);
    },
    // 设置柱状图  divID、柱状图数据、柱状图x轴下标
    setZhu(divId, zhuData, zhuIndex, colors) {
      let divData = this.$echarts.init(document.getElementById(divId));
      var series = [];
      var app = {};
      var option;
      var titleName = [];

      const posList = [
        "left",
        "right",
        "top",
        "bottom",
        "inside",
        "insideTop",
        "insideLeft",
        "insideRight",
        "insideBottom",
        "insideTopLeft",
        "insideTopRight",
        "insideBottomLeft",
        "insideBottomRight",
      ];
      app.configParameters = {
        rotate: {
          min: -90,
          max: 90,
        },
        align: {
          options: {
            left: "left",
            center: "center",
            right: "right",
          },
        },
        verticalAlign: {
          options: {
            top: "top",
            middle: "middle",
            bottom: "bottom",
          },
        },
        position: {
          options: posList.reduce(function (map, pos) {
            map[pos] = pos;
            return map;
          }, {}),
        },
        distance: {
          min: 0,
          max: 100,
        },
      };
      app.config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function () {
          const labelOption = {
            rotate: app.config.rotate,
            align: app.config.align,
            verticalAlign: app.config.verticalAlign,
            position: app.config.position,
            distance: app.config.distance,
          };
          divData.setOption({
            series: [
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
            ],
          });
        },
      };
      const labelOption = {
        show: true,
        position: app.config.position,
        distance: app.config.distance,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        rotate: app.config.rotate,
        // formatter: "{c}",
        // formatter: '{c}  {name|{a}}',
        formatter: v => {
          return this.numFormat(v.value)
        },
        fontSize: 16,
        rich: {
          name: {},
        },
      };

      if (zhuData.length > 0) {
        zhuData.forEach((item) => {
          titleName.push(item.name);
          series.push({
            name: item.name,
            type: "bar",
            barGap: 0,
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: item.data,
          });
        });
      }
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: titleName,
        },
        toolbox: {
          show: false,
          orient: "vertical",
          left: "right",
          top: "center",
          // 显示右侧选择图像功能
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        // 柱状图柱子颜色
        color: colors,
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: zhuIndex,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: series,
      };

      if (option && typeof option === "object") {
        divData.setOption(option);
      }
    },
    setCartogram() {
      this.totalIncomePie();
      this.awaitIncomeAmountPie();
      this.incomeAmountDetailsPie();
      this.refundAmountPie();
      this.consumePie();
      this.pricingZhu();
    },

    // 负数不可显示饼图
    // 总入账金额
    totalIncomePie() {
      let data = {
        orgID: this.$route.query.orgID,
      };
      var colors = ["#22BD49", "#FFC266", "#CC6699"];
      var amount = "￥0.00";
      var pieData = [];
      axios({
        method: "post",
        url: "finances",
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
          } else if (value && value.data) {
            const item = value.data.data;
            pieData = [
              { value: item.totalBill / 100, name: "缴费金额" },
              { value: item.totalBalance / 100, name: "预存金额" },
              { value: item.totalCancel / 100, name: "作废金额" },
            ];
            amount =
              "￥" + this.numFormat((item.actualIncome) / 100);
            // 总入账金额
            this.setPieData(
              "incomeAmount",
              amount,
              "实际入账金额",
              pieData,
              colors
            );
          }
        })
        .catch(() => {
          // 总入账金额
          this.setPieData(
            "incomeAmount",
            amount,
            "实际入账金额",
            pieData,
            colors
          );
        });
    },
    awaitIncomeAmountPie() {
      let data = {
        orgID: this.$route.query.orgID,
      };
      var colors = ["#FF8888", "#FF0000"];
      var amount = "￥0.00";
      var pieData = [];
      axios({
        method: "post",
        url: "finances/unpaid",
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
          } else if (value && value.data) {
            const item = value.data.data;
            pieData = [
              { value: item.unsettledAmount / 100, name: "未出账金额" },
              { value: item.settledAmount / 100, name: "欠款金额" },
            ];
            amount =
              "￥" +
              this.numFormat((item.unsettledAmount + item.settledAmount) / 100);
            // 待缴金额
            this.setPieData(
              "awaitIncomeAmount",
              amount,
              "待缴金额",
              pieData,
              colors
            );
          }
        })
        .catch(() => {
          // 待缴金额
          this.setPieData(
            "awaitIncomeAmount",
            amount,
            "待缴金额",
            pieData,
            colors
          );
        });
    },
    // 入账金额明细
    incomeAmountDetailsPie() {
      let data = {
        orgID: this.$route.query.orgID,
      };
      var amount = "￥0.00";
      var pieData = [];
      var colors = ["#FFA011", "#CC7A00", "#228822", "#2CB12C", "#5CD65C"];
      axios({
        method: "post",
        url: "finances/income",
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
          } else if (value && value.data) {
            const item = value.data.data;
            pieData = [
              { value: item.topupOnline / 100, name: "微信充值" },
              { value: item.topupOffline / 100, name: "人工充值" },
              { value: item.billOnline / 100, name: "微信缴费" },
              { value: item.billOffline / 100, name: "人工缴费" },
              { value: item.billSys / 100, name: "其它缴费" },
            ];
            amount =
              "￥" +
              this.numFormat(
                (item.topupOnline +
                  item.topupOffline +
                  item.billOnline +
                  item.billOffline +
                  item.billSys) /
                  100
              );
          }
          // 入账金额明细
          this.setPieData(
            "incomeAmountDetails",
            amount,
            "总入账金额",
            pieData,
            colors
          );
        })
        .catch(() => { 
          // 入账金额明细
          this.setPieData(
            "incomeAmountDetails",
            amount,
            "总入账金额",
            pieData,
            colors
          );
        });
    },
    // 退款金额
    refundAmountPie() {
      let data = {
        orgID: this.$route.query.orgID,
      };
      var amount = "￥0.00";
      var pieData = [];
      var colors = ["#777777", "#999999"];
      axios({
        method: "post",
        url: "finances/refund",
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
          } else if (value && value.data) {
            const item = value.data.data;
            pieData = [
              { value: item.refundOnline / 100, name: "微信退款" },
              { value: item.refundOffline / 100, name: "人工退款" },
            ];
            amount =
              "￥" +
              this.numFormat((item.refundOnline + item.refundOffline) / 100);
          }
          // 退款总金额
          this.setPieData(
            "refundAmount",
            amount,
            "总退款金额",
            pieData,
            colors
          );
        })
        .catch(() => {
          // 退款总金额
          this.setPieData(
            "refundAmount",
            amount,
            "总退款金额",
            pieData,
            colors
          );
        });
    },
    // 缴费项目柱状图
    pricingZhu(){
      let data = {
        orgID: this.$route.query.orgID,
      };
      var zhuIndex =['房租押金','房租租金', '水费', '电费']
      var zhuData =[{name:'应收金额',data:[0,0,0,0,0]},{name:'实收金额',data:[0,0,0,0,0]},{name:'欠款金额',data:[0,0,0,0,0]},{name:'未出账金额',data:[0,0,0,0,0]}]
      var totalAmounts = []; //应收
      var paidAmounts = []; //实收
      var settledAmounts = []; //欠款
      var unsettledAmounts = []; //未出账
      var zhuColors = ["#09B6EF", "#22BD49", "#ED3930", "#FF8888"];
      axios({
        method: "post",
        url: "finances/pricing",
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
          } else if (value && value.data) {
            
            if (value.data.data.length > 0) {
              zhuData = []; //数据
              zhuIndex = []; //下标
              value.data.data.forEach((pricing) => {
                zhuIndex.push(pricing.name);
                totalAmounts.push(pricing.totalAmount / 100);
                paidAmounts.push(pricing.paidAmount / 100);
                settledAmounts.push(pricing.settledAmount / 100);
                unsettledAmounts.push(pricing.unsettledAmount / 100);
                // totalAmounts.push(this.numFormat(pricing.totalAmount / 100));
                // paidAmounts.push(this.numFormat(pricing.paidAmount / 100));
                // settledAmounts.push(this.numFormat(pricing.settledAmount / 100));
                // unsettledAmounts.push(this.numFormat(pricing.unsettledAmount / 100));
              });
              zhuData.push(
                { name: "应收金额", data: totalAmounts },
                { name: "实收金额", data: paidAmounts },
                { name: "欠款金额", data: settledAmounts },
                { name: "未出账金额", data: unsettledAmounts }
              );
            }
          }
          // 缴费项目
          this.setZhu("paymentProject", zhuData, zhuIndex, zhuColors);
        })
        .catch(() => {
          // 缴费项目
          this.setZhu("paymentProject", zhuData, zhuIndex, zhuColors);
        });
    },
    // 应收总金额与实收总金额统计饼图
    consumePie() {
      let data = {
        orgID: this.$route.query.orgID,
      };

      var allAmount = "￥0.00";
      var allPieData = [];
      var sourcesAmount = "￥0.00";
      var sourcesPieData = [];
      var sourceColors = ["#2DC607", "#45F819"];
      var totalColors = ["#22BD49", "#ED3930"];
      axios({
        method: "post",
        url: "finances/bill",
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
          } else if (value && value.data) {
            // 总计
            const all = value.data.data.all;
            allPieData = [
              { value: all.paidAmount / 100, name: "实收" },
              { value: all.unpaidAmount / 100, name: "待缴" },
            ];
            allAmount = "￥" + this.numFormat(all.totalAmount / 100);

            // 总计
            const sources = value.data.data.sources;
            sourcesPieData = [
              { value: sources.billPayment / 100, name: "账单缴费" },
              { value: sources.balance / 100, name: "余额抵扣" },
            ];
            sourcesAmount =
              "￥" +
              this.numFormat((sources.billPayment + sources.balance) / 100);
          }
          // 缴费总计
          this.setPieData(
            "paymentTotal",
            allAmount,
            "应收总金额",
            allPieData,
            totalColors
          );
          // 缴费来源
          this.setPieData(
            "paymentSource",
            sourcesAmount,
            "实收总金额",
            sourcesPieData,
            sourceColors
          );
        })
        .catch(() => {
          // 缴费总计
          this.setPieData(
            "paymentTotal",
            allAmount,
            "应收总金额",
            allPieData,
            totalColors
          );
          // 缴费来源
          this.setPieData(
            "paymentSource",
            sourcesAmount,
            "实收总金额",
            sourcesPieData,
            sourceColors
          );
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style.css";
.item-title {
  text-align: start;
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.item-main {
  box-sizing: border-box;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.item-line {
  width: 100%;
  height: 1px;
  background: gray;
}
.box-card {
  width: 300px;
}
.item-main-plus {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.item {
  font-weight: bold;
  font-size: 25px;
}
</style>
